import React from "react";
import { Sparkles } from "lucide-react";
import { inputCls } from "./onboardShared";

function FolderField({ w }) {
  return (
    <div>
      <div className="label-tiny mb-2">Target folder</div>
      <select data-testid="domains-folder-select" value={w.folderId} onChange={(e) => w.setFolderId(e.target.value)} className={inputCls}>
        <option value="">No folder (unfiled)</option>
        {w.folders.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        <option value="__new__">＋ Create new folder…</option>
      </select>
      {w.folderId === "__new__" && (
        <input data-testid="domains-new-folder-name" autoFocus value={w.newFolderName} onChange={(e) => w.setNewFolderName(e.target.value)} placeholder="New folder name (e.g. Server 2)" className="admin-input w-full bg-transparent border border-amber-500/40 px-3 py-2 rounded-sm text-sm mt-2" />
      )}
      <div className="text-[11px] text-zinc-500 mt-1">The whole batch lands in this folder (created with the provider below).</div>
    </div>
  );
}

function ProviderFields({ w }) {
  if (w.emailProvider !== "sparkpost") {
    return (
      <div className="border border-sky-500/30 bg-sky-500/5 rounded-sm p-3">
        <div className="text-[11px] text-sky-300 leading-relaxed">Infobip uses your global account credentials — no per-site key. Each site&apos;s domain auto-registers with Infobip and its DNS records publish to Cloudflare once the zone activates.</div>
      </div>
    );
  }
  return (
    <div>
      <div className="label-tiny mb-2">SparkPost API key (optional)</div>
      <input data-testid="domains-sp-key" type="password" value={w.spKey} onChange={(e) => w.setSpKey(e.target.value)} placeholder="finishes email sending automatically" className={`${inputCls} mono`} />
      {w.spKey.trim() && <input data-testid="domains-sp-sub" value={w.spSub} onChange={(e) => w.setSpSub(e.target.value)} placeholder="Subaccount ID (optional)" className={`${inputCls} mono mt-2`} />}
      <div className="text-[11px] text-zinc-500 mt-1">Stored on each site. Once a domain's Cloudflare zone activates, the DNS matrix runs automatically — zero follow-up.</div>
    </div>
  );
}

function SiteTypeField({ w }) {
  const isStatic = w.siteType === "static";
  return (
    <div>
      <div className="label-tiny mb-2">Site type</div>
      <select data-testid="domains-site-type" value={w.siteType} onChange={(e) => w.setSiteType(e.target.value)} className={inputCls}>
        <option value="news">News network (RSS feeds + AI rewrites)</option>
        <option value="static">Static lead-gen (loan request clone, no feeds)</option>
      </select>
      <div className="text-[11px] text-zinc-500 mt-1">
        {isStatic
          ? "12 fixed pages (Home, How It Works, Rates & Fees, FAQ, Contact, legal). Random light palette + fonts, no images, copy lightly reworded once by AI. Paste your JS form snippet afterwards (Settings or the bulk “Form snippet” action)."
          : "Full newsroom: seeded safe RSS sources, AI rewrites, categories and article pages."}
      </div>
    </div>
  );
}

/** Review phase — left card: folder, provider, look, catch-all, SparkPost key, spend cap. */
export function ReviewConfigCard({ w }) {
  return (
    <div className="border border-zinc-800 bg-zinc-900/40 rounded-sm p-5 space-y-4">
      <SiteTypeField w={w} />
      <FolderField w={w} />
      <div>
        <div className="label-tiny mb-2">Email provider</div>
        <select data-testid="domains-provider-select" value={w.emailProvider} onChange={(e) => w.setEmailProvider(e.target.value)} className={inputCls}>
          <option value="sparkpost">SparkPost (default)</option>
          <option value="infobip">Infobip</option>
        </select>
        <div className="text-[11px] text-zinc-500 mt-1">Transactional email provider for every site in this batch. Override per-site later on the Sites page.</div>
      </div>
      {w.siteType !== "static" && (
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input data-testid="domains-applylook" type="checkbox" checked={w.applyLook} onChange={(e) => w.setApplyLook(e.target.checked)} />
        <Sparkles size={14} className="text-amber-400" /> Give each site a unique distinct look (anti-footprint)
      </label>
      )}
      <div>
        <div className="label-tiny mb-2">Email catch-all forwards to</div>
        <input data-testid="domains-email-forward" value={w.emailForward} onChange={(e) => w.setEmailForward(e.target.value)} placeholder="processing@citirex.com" className={`${inputCls} mono`} />
        <div className="text-[11px] text-zinc-500 mt-1">Defaults to <span className="mono">processing@citirex.com</span> if left blank. Must be a verified Cloudflare destination to deliver.</div>
      </div>
      <ProviderFields w={w} />
      {w.buyMode && (
        <div>
          <div className="label-tiny mb-2">Spend cap (optional, USD)</div>
          <input data-testid="domains-spendcap" value={w.spendCap} onChange={(e) => w.setSpendCap(e.target.value)} placeholder="e.g. 50" className={`${inputCls} mono`} />
        </div>
      )}
    </div>
  );
}
